import React, { useState } from 'react';
import { Header } from '../../../header/Header/Header';
import MainSider from '../sider/MainSider/MainSider';
import MainContent from '../MainContent/MainContent';
import { MainHeader } from '../MainHeader/MainHeader';
import { useResponsive } from '@app/hooks/useResponsive';
import * as S from './MainLayout.styles';
import { Outlet } from 'react-router-dom';

const MainLayout: React.FC = () => {
  const [isTwoColumnsLayout] = useState(false);
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const { isTablet } = useResponsive();

  const toggleSider = () => setSiderCollapsed(!siderCollapsed);

  return (
    <S.LayoutMaster>
      <MainSider isCollapsed={siderCollapsed} setCollapsed={setSiderCollapsed} />
      <S.LayoutMain>
        {/* The header is only rendered below tablet, where its burger is the
            sole way to open the sider -- the sider collapses to zero width on
            mobile and SiderLogo's collapse button is tablet-only. From tablet
            up the header has nothing left in it (profile moved to the sider
            footer), so it is dropped and the page content starts at the top. */}
        {!isTablet && (
          <MainHeader isTwoColumnsLayout={isTwoColumnsLayout}>
            <Header toggleSider={toggleSider} isSiderOpened={!siderCollapsed} isTwoColumnsLayout={isTwoColumnsLayout} />
          </MainHeader>
        )}
        <MainContent id="main-content" $isTwoColumnsLayout={isTwoColumnsLayout}>
          <div>
            <Outlet />
          </div>
        </MainContent>
      </S.LayoutMain>
    </S.LayoutMaster>
  );
};

export default MainLayout;
